import React, { useState } from "react";
import { Form, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import OtherCardForm from "./OtherCardForm";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useSuccessErrorModal from "../../hooks/successErrorModal/useSuccessErrorModal";
import Endpoints from "../../api/endpoints";
import EndpointFunctions from "../../utils/Functions/endpointFunctions";
import PageRoutes from "../../utils/routes";

const CreateOtherCard = () => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();

  const createOtherCard = async (values) => {
    setIsLoading(true);
    const requestBody = {
      id: 8,
      companyName: values.companyName,
      color: values.color,
      isCommonlyUsed: values.isCommonlyUsed,
      status: values.status,
      barcodeFormat: null,
    };
    console.log("requestBody", requestBody);
    // Create FormData for file upload
    const formData = new FormData();
    const json = JSON.stringify(requestBody);
    const blob = new Blob([json], {
      type: "application/json",
    });
    formData.append("request", blob);

    if (values.logo) {
      formData.append("image", values.logo);
    }

    const result = await EndpointFunctions.postData({
      endpointURL: Endpoints.addOtherCard,
      formData: formData,
      axiosPrivate: axiosPrivate,
      isMultiPart: true,
    });

    setIsLoading(false);

    if (result.success) {
      showModal("Başarılı", "Diğer kart başarıyla eklendi.", () => {
        closeModal();
        navigate(PageRoutes.otherCards);
      });
    } else {
      showModal(result.errorTitle, result.errorMessage, () => {
        closeModal();
      });
    }
  };

  return (
    <div>
      <OtherCardForm
        form={form}
        onFinish={createOtherCard}
        isLoading={isLoading}
      />
      <ModalComponent />
    </div>
  );
};

export default CreateOtherCard;
